// extracted by mini-css-extract-plugin
module.exports = {"tipWrapper":"styles_tipWrapper__bj0Ol"};